export default __webpack_public_path__ + "img/Montserrat-Thin_555f03e.ttf";